import { Setter, WritableAtom } from "jotai";

interface GetUrlParams<T> {
  newValue: T | null;
  atom: WritableAtom<T, [T], void>;
  set: Setter;
  searchParamKey: string;
  defaultValue: T;
}

export const getUrlParams = <T>({ newValue, set, atom, searchParamKey, defaultValue }: GetUrlParams<T>) => {
  if (newValue !== null) {
    set(atom, newValue);
    return;
  }

  const searchParams = new URLSearchParams(window.location.search);
  const param = searchParams.get(searchParamKey);

  if (param) {
    try {
      const parsedValue = JSON.parse(param) as T;
      set(atom, parsedValue);
    } catch (error) {
      console.error(`Failed to parse ${searchParamKey}:`, error);
      set(atom, defaultValue);
    }
  } else {
    set(atom, defaultValue);
  }
};
